import type { IFilterableListItem, IOmit, ISelectProps } from '@sixui/ui';
import { forwardRef } from 'react';
import { Field, Select, Skeleton } from '@sixui/ui';

import { ErrorMessage } from '~/components/molecules/ErrorMessage';
import { useUserBadgesQuery } from '~/lib/api/modules/UserBadges/hooks/useUserBadgesQuery';

export type IUserBadgeSelectorProps = IOmit<ISelectProps, 'items'> & {
  appId: string;
};

export const UserBadgeSelector = forwardRef<
  HTMLInputElement,
  IUserBadgeSelectorProps
>(function UserBadgeSelector(props, forwardedRef) {
  const { appId, ...other } = props;
  const userBadgesQuery = useUserBadgesQuery({ appId });
  const items: Array<IFilterableListItem> =
    userBadgesQuery.data?.userBadges.map(({ _id, name }) => ({
      value: _id,
      label: name,
    })) ?? [];

  return userBadgesQuery.isError ? (
    <ErrorMessage error={userBadgesQuery.error} />
  ) : !!userBadgesQuery.data || !userBadgesQuery.isLoading ? (
    <Select
      {...other}
      items={items}
      ref={forwardedRef}
      disabled={userBadgesQuery.isLoading}
    />
  ) : (
    <Skeleton>
      <Field />
    </Skeleton>
  );
});
